// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"9fe9b391","156":"6c9492be","438":"387cc76a","706":"4140d3ed","726":"7305d914","785":"7a7d52cd"}[chunkId] + ".chunk.js";
};